import userManager from './auth/authService';
import { getApiKey } from './auth/apiKeyService';

export const impersonateUser = async (email: string) => {
  try {
    localStorage.setItem('impersonateEmail', email);
    window.location.reload();
  } catch (error) {
    console.error("Failed to impersonate user:", error);
  }
}

export const authFetch = async (url: string, options: RequestInit = {}, skipCT:boolean = false) => {

  const apiKey = getApiKey();
  const accessToken = apiKey ? null : (await userManager.getUser())?.access_token
  const impersonatedUser = localStorage.getItem('impersonateEmail');
  if(impersonatedUser) {
    options.headers = {
      ...options.headers,
      'X-Impersonate-User-Id': impersonatedUser
    }
  }

  const headersObj = (options.headers && !(options.headers instanceof Headers))
    ? options.headers as Record<string, string>
    : {};
  const contentType = (headersObj['Content-Type'] ?? null) || 'application/json';

  const headers: any = {
    ...options.headers,
    ...(apiKey ? { 'X-API-Key': apiKey } : { Authorization: `Bearer ${accessToken}` }),
  }

  if(!skipCT) {
    headers['Content-Type'] = contentType;
  }

  return fetch(url, {
    ...options,
    headers
  });
}